import TextArea from 'antd/es/input/TextArea';
import React, { useState } from 'react';
import { PlusOutlined, CloseOutlined } from "@ant-design/icons";
import { Button, DatePicker, Form, Input, Popconfirm, Row, Select, Table, Typography } from 'antd';
import { elements } from 'chart.js';


const { Title } = Typography

const ChartTable = ({ tableTitle, column1, column2, column3, column4, column5, index1, index2, index3, index4, index5, groupingByAmount, periodTypeOptions, disabled
 }) => {

    // console.log(chartSlabs)

    const [count, setCount] = useState(0);
    const [dataSource, setDataSource] = useState([{}]);

    const handleDelete = (key) => {
        const newData = dataSource.filter((item) => item.key !== key);
        setDataSource(newData);
    };

    const handleAdd = () => {
        const newData = {
            key: count,
            // paymentType: `Edward King ${count}`,
            // fundSource: '32'
        };
        setDataSource([...dataSource, newData]);
        setCount(count + 1);
    };

    const defaultColumns = 
        [
            {
                key: 0,
                title: column1,
                dataIndex: index1,
                // width: "15%",
                render: () => (!groupingByAmount ?
                    <Form.Item name={"periodType"}>
                        <Select
                            placeholder={"Please select a value"}
                            options={periodTypeOptions}
                            style={{ width: "10vh" }}
                            disabled={disabled}
                        />
                    </Form.Item>
                    : <Row>
                        <Form.Item name={"amountRangeFrom"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item>-
                        <Form.Item name={"amountRangeTo"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item>
                    </Row>)
            },
            {
                key: 1,
                title: column2,
                dataIndex: index2,
                // width: "15%",
                render: () => (!groupingByAmount ?
                    <Row>
                        <Form.Item name={"fromPeriod"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item> -
                        <Form.Item name={"toPeriod"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item></Row> :
                    <Form.Item name={"periodType"}>
                        <Select
                            placeholder={"Please select a value"}
                            options={periodTypeOptions}
                            style={{ width: "10vh" }}
                            disabled={disabled}
                        />
                    </Form.Item>)
            },
            {
                key: 2,
                title: column3,
                dataIndex: index3,
                render: () => (!groupingByAmount ?
                    <Row>
                        <Form.Item name={"amountRangeFrom"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item> -
                        <Form.Item name={"amountRangeTo"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item>
                    </Row> :
                    <Row>
                        <Form.Item name={"fromPeriod"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item> -
                        <Form.Item name={"toPeriod"}>
                            <Input style={{ width: "10vh" }} disabled={disabled}/>
                        </Form.Item>
                    </Row>)
            },

            {
                key: 3,
                title: column4,
                dataIndex: index4,
                // width: "10%",
                render: () =>
                    <Form.Item name={"annualInterestRate"}>
                        <Input style={{ width: "10vh" }} disabled={disabled} />
                    </Form.Item>
            },
            {
                key: 4,
                title: column5,
                dataIndex: index5,
                // width: "20%",
                render: () =>
                    <Form.Item>
                        <TextArea style={{ width: "15vh" }} disabled={disabled}/>
                    </Form.Item>
            },

            {
                key: 5,
                title: <Button
                    onClick={handleAdd}
                    type="primary"
                    icon={<PlusOutlined />}
                    style={{ backgroundColor: "#92428B", color: "white", width: "" }}
                > Add
                </Button>,
                dataIndex: 'actions',
                render: (_, record) =>
                    dataSource.length >= 1 ? (
                        <Popconfirm title="Sure to delete?" onConfirm={() => handleDelete(record.key)}>
                            <CloseOutlined style={{ color: "#92428B", fontSize: "15px", fontWeight: "bolder" }} />
                        </Popconfirm>
                    ) : null,
            },


        ]


    const columns = defaultColumns.map((col) => {
        if (!col.editable) {
            return col;
        }
    });

    return (
        <div>
            <Row justify={'space-between'} align={'middle'}>
                <Title level={5} style={{ paddingTop: 10, paddingBottom: 10, marginTop: 10, marginBottom: 10 }}>{tableTitle}</Title>

            </Row>
            <Table
                rowClassName={() => 'editable-row'}
                dataSource={dataSource}
                columns={columns}
                pagination={false}
            />
        </div>
    );
};

export default ChartTable;
